export default __webpack_public_path__ + "static/media/Abel-Regular.303334d0.woff";